import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change, reset } from 'redux-form';
import { SingleInputForm } from '../../../../../../components/common/elements';
import { FormFieldHelpers as Form, cssUnit, getParent } from '../../../../../../helpers';
import jobsActions from '../../../../../../actions/jobs/jobs';
import { siteOfOriginHelper, countryAbbrToCode } from '../../../../../../helpers/genericHelpers.js';
import Anchor from "../../../../../dashboardNew/objects/Anchor";

class JobSearchForm extends React.Component {

	constructor() {
		super();
		this.state = { isAdvancedOpen: false, searchName: "" };

		this.fieldRegion = React.createRef();
		this.fieldIndustry = React.createRef();
		this.fieldExpertise = React.createRef();
	}

	componentWillReceiveProps(nextProps) {
		this.props.selectedJobCountry !== undefined && this.props.selectedJobCountry !== nextProps.selectedJobCountry && this.props.resetLocation();
	}

	saveSearch = formData => {
		const searchData = { ...this.props.formValues.values, name: formData.single_input };
		this.props.saveSearch(localStorage.getItem('person_id'), searchData, true);
		this.setState({ isPopperOpen: false });
		this.props.resetSingleInput();
	};

	advancedJobOptions() {
		return (
			<React.Fragment>
				<div className="col-12 form-group" ref={this.fieldIndustry} >
					<Field
						name="industry_id"
						placeholder="Select Industry..."
						clearable="true"
						multi={true}
						classNamePrefix="select"
						component={Form.selectField}
						onChange={this.onChangeHandler.bind(this, this.fieldIndustry)}
						onFocus={this.onFocusHandler.bind(this)}
						options={this.props.advanced.industries.map(industry => ({ value: industry.id, label: industry.name }))}
					/>
				</div>
				<div className="col-12 form-group" ref={this.fieldExpertise} >
					<Field
						name="expertise_id"
						placeholder="Select Expertise..."
						clearable="true"
						multi={true}
						classNamePrefix="select"
						component={Form.selectField}
						onChange={this.onChangeHandler.bind(this, this.fieldExpertise)}
						onFocus={this.onFocusHandler.bind(this)}
						options={this.props.advanced.expertise.map(expertise => ({ value: expertise.id, label: expertise.name }))}
					/>
				</div>
				<div className="col-12 form-group">
					<Field
						name="sector_id"
						placeholder="Select Sector..."
						component={Form.selectField}
						classNamePrefix="select"
						clearable="true"
						options={this.props.advanced.sectors.map(sector => ({ value: sector.id, label: sector.name }))} />
				</div>
			</React.Fragment>
		);
	};

	onChangeHandler(wrap, evt) {
		const container = wrap.current.querySelector('.select__value-container');
		const control = wrap.current.querySelector('.select__control');

		if (!container || !control) { return console.error('elements not found') };

		if (!this.containerHeight && !this.controlHeight) {
			this.containerHeight = window.getComputedStyle(container).getPropertyValue('height') || container.style.height || container.height;
			this.controlHeight = window.getComputedStyle(control).getPropertyValue('height') || control.style.height || control.height;
		};

		if (evt['0']) {
			container.style.height = 'auto';
			control.style.height = 'auto';
		} else {
			container.style.height = cssUnit.getUnit(this.containerHeight + '').length ? this.containerHeight : `${this.containerHeight}px`;
			control.style.height = cssUnit.getUnit(this.controlHeight + '').length ? this.controlHeight : `${this.controlHeight}px`;
		};
	}

	onFocusHandler(evt) {
		const wrap = getParent(evt.target, '.search-tool__field-wrap');
		if (wrap) { wrap.classList.add('search-tool__field-wrap--has-focused') };
	}

	showFormButtons(formHasData) {
		if (!formHasData) { return }
		return (
			<div className="save-search-hold">
				<button className="clickable" onClick={() => this.setState({ isPopperOpen: !this.state.isPopperOpen })}>
					Save This Search
				</button>
				<div className={`form--save-search ${this.state.isPopperOpen ? "is--open" : "is--closed"}`}>
					<SingleInputForm onSubmit={this.saveSearch} />
				</div>
				<div className={`form--save-search ${this.props.saveSuccessful && !this.state.isPopperOpen ? "is--open" : "is--closed"}`}>Saved</div>
			</div>
		);
	}

	render() {

		const image = '/images/jobs-board-header.jpg';
		const siteOfOrigin = siteOfOriginHelper();
		const currentCountry = this.props.locations && this.props.locations.filter(location => location.id === this.props.selectedJobCountry || (this.props.selectedJobCountry && location.id === this.props.selectedJobCountry.value))[0];
		const values = this.props.formValues && this.props.formValues.values;
		const formHasData = !!(values && (values.keyword || values.country_id || values.expertise_id || values.industry_id || values.region_id || values.remuneration_type_id || values.sector_id));
		const formHasAdvancedData = !!(values && (values.expertise_id || values.remuneration_type_id || values.sector_id || values.industry_id));

		return (
			<section
				className="search-tool search-tool--jobs item-relative" id="search-tool">
				<div className="container-fluid theme-search-form">
					<div className="image" style={{ backgroundImage: `url(${image})` }}></div>
					<div className="container jobs-page-style-fix">
						<div className="row">
							<div className="col-12 col-lg-10 col-xl-7 col-xxl-5">
								<div className="col-12">
									{this.props.jobsInfo && <h1 className="heading-main"> {this.props.jobsInfo.job_title} </h1>}
								</div>
								<div className="col-12 advanced-option">
									{this.showFormButtons(formHasData)}
									<button
										className={`theme-helper-button ${this.state.isAdvancedOpen ? "active" : ""}`}
										data-toggle="collapse"
										data-target="#advancedJobOptions"
										onClick={() => this.setState({ isAdvancedOpen: !this.state.isAdvancedOpen })}>
										Advanced
											{!this.state.isAdvancedOpen ? <i className="fa fa-right fa-angle-up button-icon" /> :
											<i className="fa fa-right fa-angle-down button-icon" />}
									</button>
								</div>
								<form onSubmit={this.props.handleSubmit}>
									<div className="col-12 form-group">
										<Field name="keyword" placeholder="Enter keyword..." clearable="true" component={Form.textField} />
									</div>

									<div className="col-12 form-group">
										<Field
											name="country_id"
											placeholder="Select Country..."
											clearable="true"
											classNamePrefix="select"
											initialValue={this.props.initialValues && this.props.initialValues.country_id ? this.props.initialValues.country_id : countryAbbrToCode(siteOfOrigin)}
											component={Form.selectField}
											options={this.props.locations && this.props.locations.map(country => ({ value: country.id, label: country.name }))} />
									</div>
									<div className="col-12 form-group" ref={this.fieldRegion}>
										<Field name="region_id" placeholder="Select Region..."
											clearable="true"
											format={null}
											multi={true}
											classNamePrefix="select"
											component={Form.selectField}
											onChange={this.onChangeHandler.bind(this, this.fieldRegion)}
											onFocus={this.onFocusHandler.bind(this)}
											options={currentCountry && currentCountry.regions.map(region => ({ value: region.id, label: region.name }))}
										/>
									</div>

									<div className={`collapse ${formHasAdvancedData ? 'in' : ''}`} id="advancedJobOptions">
										{this.advancedJobOptions()}
									</div>

									<div className="col-12 form-button">
										<div className="start-hold">
											<button type="submit" className="theme-button">
												Find roles
											</button>
										</div>

										<button type="button" onClick={ev => this.props.clearForm(ev)} className="clickable">
											Clear Search
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
				<div className="container-fluid theme-banner-favourites">
					<div className="container">
						<div className="row">
							<ul className="favourite-list">
								<li className="favourite-item">
									<Anchor internal path={'/my-jobs-section/favourite-jobs'} anchorClass={'favourite-link'} >
										<i className="fa fa-heart fa-right fav-link-icon" />
										{siteOfOrigin !== 'us' ? 'Favourite' : 'Favorite'} jobs
									</Anchor>
								</li>
								<li className="favourite-item">
									<Anchor internal path={'/my-jobs-section/saved-searches'} anchorClass={'favourite-link'} >
										<i className="fa fa-star fa-right fav-link-icon" />
										Saved searches
									</Anchor>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

JobSearchForm = reduxForm({ form: 'job_search_form' })(JobSearchForm);
const valueSelector = formValueSelector('job_search_form');

const mapStateToProps = state => ({
	selectedCountry: state.search.selectedCountry,
	selectedJobCountry: valueSelector(state, 'country_id'),
	selectedRegion: valueSelector(state, 'region_id'),
	selectedIndustry: valueSelector(state, 'industry'),
	selectedExpertise: valueSelector(state, 'expertise'),
	selectedRemunerationType: valueSelector(state, 'remuneration_type_id'),
	selectedSectors: valueSelector(state, 'sectors'),
	formValues: state.form.job_search_form,
	initialValues: state.common.initialValues,
	jobOptions: state.jobs.options,
	saveSuccessful: state.jobs.saveSuccessful
});

const mapDispatchToProps = dispatch => ({
	getJobLocations: () => dispatch(jobsActions.getJobLocations()),
	resetLocation: () => dispatch(change('job_search_form', 'region_id', null)),
	saveSearch: (personId, searchValues, flag) => dispatch(jobsActions.saveSearch(personId, searchValues, flag)),
	resetSingleInput: () => dispatch(reset('single_input_form')),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobSearchForm);



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobSearchForm.js